module.exports = __webpack_public_path__ + "img/J13308.0aa3eee3.png";